module.exports = __webpack_public_path__ + "ionicons.eot";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.eot?v=2.0.1
// module id = 480
// module chunks = 14